export default "__VITE_ASSET__f64f5c51__"